/**
 * This is a collection that keep track of all the entity UI component adapters
 */
export class EntityUIComponentAdapterCollection {

    private static instance = new EntityUIComponentAdapterCollection();

    private adapters = new Map<string, unknown>();

    public static getInstance () {
        return EntityUIComponentAdapterCollection.instance;
    }

    /**
     * Register a new adapter with the EntityUIComponentAdapterCollection.
     * @param adapterName - Must be a new adapter type name that DOES NOT already exist in the collection or else an Error will be thrown.
     * @param adapter - The adapter object that implements the necessary interface
     */
    public registerAdapter (adapterName: string, adapter: unknown) {
        if (this.adapters.has(adapterName)) {
            throw new Error(`Adapter already existed '${adapterName}'`);
        }
        this.adapters.set(adapterName, adapter);
    }


    public hasAdapterName (adapterName: string): boolean {
        return this.adapters.has(adapterName);
    }


    public getAllAdapters (): readonly string[] {
        return Array.from(this.adapters.keys());
    }


    public getAdapter (adapterName: string): unknown | undefined {
        return this.adapters.get(adapterName);
    }
}
